import { z } from 'zod'

import { ZContractId } from '../../model/schema'

export enum ReviewStage {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
}

export const ZGuestSimpleReview = z.object({
  reviewStage: z.nativeEnum(ReviewStage),
  templateIds: z.array(z.number()),
})

export const ZGuestSimpleReviewRequest = z.object({
  initialContractId: ZContractId,
  body: ZGuestSimpleReview,
})

export type TGuestSimpleReview = z.infer<typeof ZGuestSimpleReview>
export type TGuestSimpleReviewRequest = z.infer<
  typeof ZGuestSimpleReviewRequest
>
